import React, { ReactNode } from 'react';

import { Box, Skeleton, Typography } from '@mui/material';
import BackButton from '@apigrowfinance/pbolt-back-button';
import PageHeader from '@apigrowfinance/pbolt-page-header';
import { useTheme } from '@apigrowfinance/pbolt-theme-provider';
import { useNavigate } from 'react-router-dom';

import getEnumTranslation from '@utils/getEnumTranslation';

interface FlexControlsHeaderProps {
    description: ReactNode;
    isLoading: boolean;
    title: ReactNode;
}

const CustomerFlexControlsHeader = ({
    description,
    isLoading,
    title,
}: FlexControlsHeaderProps) => {
    const { theme } = useTheme();
    const navigate = useNavigate();

    return (
        <>
            <Box sx={{ mb: 2 }}>
                <BackButton
                    text={getEnumTranslation('back')}
                    iconSize={theme.spacing(2.75)}
                    buttonOptions={{
                        sx: {
                            textTransform: 'none',
                            p: 0,
                            justifyContent: 'flex-start',
                        },
                    }}
                    textOptions={{ variant: 'overline' }}
                    onClick={() => {
                        navigate(-1);
                    }}
                />
            </Box>
            <Box sx={{ width: '100%', flexGrow: 1 }}>
                <PageHeader
                    title={
                        isLoading ? (
                            <Skeleton width={160} />
                        ) : (
                            <Typography
                                sx={{
                                    color:
                                        theme?.custom?.brand?.textMain ||
                                        'text.primary',
                                }}
                                variant="h2"
                                component="h1"
                                data-testid="CreateCustomerControl-header">
                                {title}
                            </Typography>
                        )
                    }
                    description={
                        <Typography
                            variant="subtitle2"
                            component="div"
                            data-testid="CreateCustomerControl-description">
                            {description}
                        </Typography>
                    }
                />
            </Box>
        </>
    );
};

export default CustomerFlexControlsHeader;
